export enum ThemeButtonProperties {
    borderRadius = 'borderRadius',
    borderStyle = 'borderStyle',
    borderWidth = 'borderWidth',
    borderColor = 'borderColor',
    color = 'color',
    background = 'background',
}

export enum ThemeButtonHoverProperties {
    opacity = 'opacity',
    shadow = 'shadow',
    color = 'color',
    background = 'background',
    borderColor = 'borderColor',
}
